import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/providers.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/globals.css");
